'use client'

import React from 'react'
import {CartProvider as USCProvider} from 'use-shopping-cart'

type Props = {
    children: React.ReactNode
}
export default function CartProvider({children}: Props) {


    return (
        <USCProvider
            // @ts-ignore
            mode="payment"
            cartMode="checkout-session"
            stripe={process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY as string}
            currency={'BRL'}
            successUrl={'https://beckasmello.com/thank-you'}
            cancelUrl={'https://beckasmello.com/'}
            allowedCountries={['BR', 'GB', 'US']}
            billingAddressCollection={true}
        >
            {children}
        </USCProvider>
    )
}